import _forEach from "lodash/forEach";
import _find from "lodash/find";
import validator from "validator";
import _forOwn from "lodash/forOwn";



export const validateField = (name, rules, value, value2 = null) => {

    const validations = [
        {'rule': 'required', 'validator': () => !validator.isEmpty(value)},
        {'rule': 'isEmail', 'validator': () => validator.isEmail(value)},
        {'rule': 'equals', 'validator': () => validator.equals(value, value2)},
        {'rule': 'validPassword', 'validator': () => validator.isLength(value, {min: 8, max: undefined})},
    ];

    //Will return false is no errors
    let msg = false;

    _forEach(rules, (error, name) => {
        const rule = _find(validations, ['rule', name]);
        if (!rule.validator()) {
            msg = error;
            return false;
        }
        return true;
    });
    return msg;
};

export const validateForm = (errors) => {

    let is_valid = true;

    _forOwn(errors, (value, key) => {
        if (false !== value) {
            is_valid = false;
            return false;
        }
    });

    return is_valid;

};